/* unplugin-vue-components disabled */import { render } from "./SettingItem.vue?vue&type=template&id=5140cbdc&scoped=true&ts=true"
import script from "./SettingItem.vue?vue&type=script&lang=ts"
export * from "./SettingItem.vue?vue&type=script&lang=ts"

import "./SettingItem.vue?vue&type=style&index=0&id=5140cbdc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5140cbdc"]])

export default __exports__